import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=0ad2186c&scoped=true"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"
import style0 from "./Policies.vue?vue&type=style&index=0&id=0ad2186c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad2186c",
  null
  
)

export default component.exports